import { Component, Input } from '@angular/core';
import { QueryParamsHandling, TabsAlign, TabsColor } from '@freelancer/ui/tabs';

@Component({
  selector: 'app-discover-navigation',
  template: `
    <fl-tabs [color]="tabColor" [align]="tabAlignment">
      <fl-tab-item
        flTrackingLabel="DiscoverNavigation"
        title="All"
        i18n-title="Category Name for All"
        [link]="baseUrl"
        [selected]="selectedCategoryName === 'all'"
        [queryParamsHandling]="
          preserveQueryParam
            ? QueryParamsHandling.PRESERVE
            : QueryParamsHandling.NONE
        "
      >
      </fl-tab-item>
      <fl-tab-item
        flTrackingLabel="DiscoverNavigation"
        title="Website Design"
        i18n-title="Category Name for Website Design"
        [link]="baseUrl + '/website-design'"
        [selected]="selectedCategoryName === 'website-design'"
        [queryParamsHandling]="
          preserveQueryParam
            ? QueryParamsHandling.PRESERVE
            : QueryParamsHandling.NONE
        "
      >
      </fl-tab-item>
      <fl-tab-item
        flTrackingLabel="DiscoverNavigation"
        title="Mobile"
        i18n-title="Category Name for Mobile"
        [link]="baseUrl + '/mobile-app-development'"
        [selected]="selectedCategoryName === 'mobile-app-development'"
        [queryParamsHandling]="
          preserveQueryParam
            ? QueryParamsHandling.PRESERVE
            : QueryParamsHandling.NONE
        "
      >
      </fl-tab-item>
      <fl-tab-item
        flTrackingLabel="DiscoverNavigation"
        title="Graphic Design"
        i18n-title="Category Name for Graphic Design"
        [link]="baseUrl + '/graphic-design'"
        [selected]="selectedCategoryName === 'graphic-design'"
        [queryParamsHandling]="
          preserveQueryParam
            ? QueryParamsHandling.PRESERVE
            : QueryParamsHandling.NONE
        "
      >
      </fl-tab-item>
      <fl-tab-item
        flTrackingLabel="DiscoverNavigation"
        title="Logo Design"
        i18n-title="Category Name for Logo Design"
        [link]="baseUrl + '/logo-design'"
        [selected]="selectedCategoryName === 'logo-design'"
        [queryParamsHandling]="
          preserveQueryParam
            ? QueryParamsHandling.PRESERVE
            : QueryParamsHandling.NONE
        "
      >
      </fl-tab-item>
      <fl-tab-item
        flTrackingLabel="DiscoverNavigation"
        title="3D Modeling"
        i18n-title="Category Name for 3D Modeling"
        [link]="baseUrl + '/3d-modeling'"
        [selected]="selectedCategoryName === '3d-modeling'"
        [queryParamsHandling]="
          preserveQueryParam
            ? QueryParamsHandling.PRESERVE
            : QueryParamsHandling.NONE
        "
      >
      </fl-tab-item>
      <fl-tab-item
        flTrackingLabel="DiscoverNavigation"
        title="Illustration"
        i18n-title="Category Name for Illustration"
        [link]="baseUrl + '/illustration'"
        [selected]="selectedCategoryName === 'illustration'"
        [queryParamsHandling]="
          preserveQueryParam
            ? QueryParamsHandling.PRESERVE
            : QueryParamsHandling.NONE
        "
      >
      </fl-tab-item>
      <fl-tab-item
        flTrackingLabel="DiscoverNavigation"
        title="Branding"
        i18n-title="Category Name for Branding"
        [link]="baseUrl + '/branding'"
        [selected]="selectedCategoryName === 'branding'"
        [queryParamsHandling]="
          preserveQueryParam
            ? QueryParamsHandling.PRESERVE
            : QueryParamsHandling.NONE
        "
      >
      </fl-tab-item>
      <fl-tab-item
        flTrackingLabel="DiscoverNavigation"
        title="Product Design"
        i18n-title="Category Name for Product Design"
        [link]="baseUrl + '/product-design'"
        [selected]="selectedCategoryName === 'product-design'"
        [queryParamsHandling]="
          preserveQueryParam
            ? QueryParamsHandling.PRESERVE
            : QueryParamsHandling.NONE
        "
      >
      </fl-tab-item>
      <fl-tab-item
        flTrackingLabel="DiscoverNavigation"
        title="Package Design"
        i18n-title="Category Name for Package Design"
        [link]="baseUrl + '/package-design'"
        [selected]="selectedCategoryName === 'package-design'"
        [queryParamsHandling]="
          preserveQueryParam
            ? QueryParamsHandling.PRESERVE
            : QueryParamsHandling.NONE
        "
      >
      </fl-tab-item>
      <fl-tab-item
        flTrackingLabel="DiscoverNavigation"
        title="Wordpress"
        i18n-title="Category Name for Wordpress"
        [link]="baseUrl + '/wordpress'"
        [selected]="selectedCategoryName === 'wordpress'"
        [queryParamsHandling]="
          preserveQueryParam
            ? QueryParamsHandling.PRESERVE
            : QueryParamsHandling.NONE
        "
      >
      </fl-tab-item>
    </fl-tabs>
  `,
})
export class DiscoverNavigationComponent {
  TabsAlign = TabsAlign;
  QueryParamsHandling = QueryParamsHandling;
  @Input() baseUrl: string;
  @Input() preserveQueryParam = false;
  @Input() selectedCategoryName: string;
  @Input() tabColor = TabsColor.DARK;
  @Input() tabAlignment = TabsAlign.LEFT;
}
